import AppointmentStatusBadge, { statusLabelLookup } from './AppointmentStatusBadge';

export { statusLabelLookup };
export default AppointmentStatusBadge;
